import application_settings from '../applicationSettings';
import Event from './Event';

class DeleteAddress extends Event {
  eventName = "oms_deleteAddress";

  constructor() {
    super();
    this.add();
  }

  /**
   * @override
   *
   * Event Function for Get loyalty points
   *
   * @param {string} data.id - id given for address
   * @return void
   *
   */
  eventFunction(data) {
      let thisObj = this;
      let requestId = data.request_id ? data.request_id : "";
      let action = data.action ? data.action : "";
      let id = data.id ? data.id : "";
      
      data.endPoint = application_settings.endPoints.deleteAddress;
      data.method = 'POST';
      data.canUsePublicAuth = false;
      data.data = {
        id: id
      };

      this.sendRequest(data, function (response) {
        if (response) {
          //format response data
          let data = thisObj.formatResponseData(response);

          //fire success event
          thisObj.onSuccessEvent(data, {
            action: action,
            request_id: requestId,
          });
        }
      });
    }
}

export default DeleteAddress;